var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "44px",
    height: "18px",
    viewBox: "0 0 44 18",
    style: {
      enableBackground: "new 0 0 44 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#0070BF;}\r\n\t.st2{fill:#FFAA00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appbar-icon-logo",
    transform: "translate(-293.615 -124.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 293.6,
    y: 124.5,
    className: "st0",
    width: 44,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3",
    transform: "translate(294.513 125.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    className: "st1",
    d: "M9.6,0L9.6,0L0,6.7l0,0h0v10h4.5V9.1l5-3.5l5,3.5v7.7h4.5v-10l0,0L9.6,0L9.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    className: "st2",
    d: "M32.6,0L32.6,0l-9.6,6.7l0,0h0v10h4.5V9.1l5-3.5l5,3.5v7.7h4.5v-10l0,0L32.6,0L32.6,0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo_main.283f549269a27d8f2b999d262d670fdd.svg";
export { ForwardRef as ReactComponent };